import { resolveContentLanguage, DEFAULT_LOCALE } from 'utils/localePath';

export const getApiLanguage = () => {
  if (typeof window !== 'undefined') {
    return resolveContentLanguage(window.location.pathname);
  }
  const stored = localStorage.getItem('i18nextLng') || DEFAULT_LOCALE;
  return stored.split('-')[0].toLowerCase();
};

export const normalizeLanguageCode = (code) => {
  if (!code) return '';
  return code.split('-')[0].toLowerCase();
};

export const isCompanyLanguage = (code, languages = []) => {
  const normalized = normalizeLanguageCode(code);
  return languages.some((lang) => lang.code_iso2 === normalized);
};
